/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is the regex built?`)
};

const es_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se construye la expresión regular?`)
};

const de_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird der Regex erstellt?`)
};

const nl_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt de regex opgebouwd?`)
};

const fr_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la regex est-elle construite ?`)
};

const it_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene costruita l'espressione regolare?`)
};

const pt_br2_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a regex é construída?`)
};

const pt_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é construída a regex?`)
};

const ja_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正規表現はどのように構築されますか？`)
};

const zh_iupac_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正则表达式是如何构建的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_q2", locale)
	if (locale === "en") return en_iupac_faq_q2(inputs)
	if (locale === "es") return es_iupac_faq_q2(inputs)
	if (locale === "de") return de_iupac_faq_q2(inputs)
	if (locale === "nl") return nl_iupac_faq_q2(inputs)
	if (locale === "fr") return fr_iupac_faq_q2(inputs)
	if (locale === "it") return it_iupac_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_q2(inputs)
	if (locale === "pt") return pt_iupac_faq_q2(inputs)
	if (locale === "ja") return ja_iupac_faq_q2(inputs)
	return zh_iupac_faq_q2(inputs)
};